import "../styles/css/bootstrap.min.css";
import { useContext, useEffect, useState } from "react";
import Toast from 'react-bootstrap/Toast';
import logo from '../assets/logo/logo.jpg';
import Axios from "axios";
import PaysContext from "../contexts/payscontext";
import Pdfpaysbulletin from './Pdfpaysbulletin';






function Postformulaire(props) {
  const payscourant = useContext(PaysContext); //PaysContext
  const adminExiste = props.adminExiste
  

  const urlpost = "http://localhost:8000/eagrimetApi/regionInfo/";  
  const [error, setError] = useState(null);
  
  const [objRegion, setObjRegion] = useState({
    code: "",
    region: "",
    langue: "",
    sourceinfo: "",
    dateCreation: null,    
    alertMessage: "",
  });

  
  

  const[bulletinPdf, SetBulletinPdf] = useState("");
  const[bulletinImage, SetBulletinImage] =  useState("");
  const[bulletinAudio, SetBulletinAudio] = useState("");
  const[message, SetMessage] = useState("");
  const[btnvalider, SetBtnvalider] =  useState(false)
  const [showMsg, SetShowMsg] = useState(false);
  const [showform, SetShowForm ] = useState(true);
  const createMessage ="Ajout effectué avec Succès"  
  
  const toggleShowMsg = () => {SetShowMsg(false) } 
  const ouvreMsg = () => {SetShowMsg(true); SetBtnvalider(false)}

  

  function handle(e) {
    const newobjRegion = { ...objRegion };
    newobjRegion[e.target.id] = e.target.value;
    setObjRegion(newobjRegion);
    console.log(newobjRegion);
  }

  function effaceChamp() {
    setObjRegion({...objRegion, code: "", region:"", langue:"", sourceinfo: "", alertMessage: ""})
    
  }

  async function submit(e) {
    let axiosConfig = {
      headers : {
         "Content-Type": "multipart/form-data",
         
      }
    }


    const form = document.getElementById("form");
    e.preventDefault();
    const formdata = new FormData(form);

    // console.log([...formdata])
    formdata.append("code", objRegion.code);
    formdata.append("region", objRegion.region);
    formdata.append("langue", objRegion.langue);
    formdata.append("sourceinfo", objRegion.sourceinfo);
    formdata.append("dateCreation", "");
    //formdata.append("bulletinPdf", objRegion.bulletinPdf);      
    //formdata.append("bulletinImage",objRegion.bulletinImage);  
    formdata.append("bulletinAudio",bulletinAudio);     
    formdata.append("alertMessage", objRegion.alertMessage);       
    formdata.append("pays", payscourant);

    console.log([...formdata]);

    Axios.post(
      urlpost,
      formdata, 
      axiosConfig      
    )
      .then((result) => {
        console.log(result.status);  
        ouvreMsg();
        effaceChamp(); 
          
       
      })
      .catch((err) => console.log(err));
      //window.location.reload();
      
  }


  if (adminExiste && props.modecreation) {

    //if(showform){

  return (    
    <div className="justify-content-center container p-2">  
     
        
      <form id="form" onSubmit={(e) => {submit(e)} } > 
        <Pdfpaysbulletin payscourant={payscourant}/>
        <h1>Creation {payscourant} </h1>

          <div className='d-flex flex-row-reverse'>
            {showMsg && 
                <Toast show={showMsg} onClose={toggleShowMsg} >
                <Toast.Header className='bg-success'>
                    <img src={logo} className='rounded-circle' height={30}  alt=""/>
                    <strong>&nbsp; eAgrimet</strong>
                </Toast.Header>
                <Toast.Body>{createMessage} </Toast.Body>            
            </Toast>
            }
            
          </div>

      <div className="row">
            <div className="mb-4 col-3">                   
            <input 
                placeholder="code"
                type="text"
                id="code"               
                onChange={(e) => handle(e)}
                className="form-control"
               value={objRegion.code}
            />
            </div>
            <div className="mb-4 col-3"> 
            <input
            placeholder="Localite"
            type="text"
            id="region"            
            onChange={(e) => handle(e)}
            className="form-control"
            value={objRegion.region}
            />
            </div>
        </div>
        <div className="row">

        <div className="mb-4 col-3"> 
        <input
          placeholder="langue"
          type="text"
          id="langue"          
          onChange={(e) => handle(e)} 
          className="form-control"
          value={objRegion.langue}
        />
        </div>
        <div className="mb-4 col-3"> 
        <input
          placeholder="Source"
          type="text"
          id="sourceinfo"          
          onChange={(e) => {handle(e); SetBtnvalider(true)}}
          className="form-control"
          value={objRegion.sourceinfo}
        />
        </div>
        </div>
        <div className="mb-4 col-6"> 
        <textarea
          placeholder="alertMessage"
          id="alertMessage"          
          onChange={(e) => handle(e)}
          className="form-control"
          value={objRegion.alertMessage}
        />
        </div>
        <div className="row" >
          <div className="mb-4 col-4" hidden > 
          <label for="bulletinPdf" className="form-label">PDF</label>
          <input
            placeholder="bulletinPdf"
            id="bulletinPdf"
            type="file"
            accept="application/pdf, .pdf" 
            onChange={(e) => {SetBulletinPdf(e.target.files[0])}}
            className="form-control"
            
          />
          </div>
        <div className="mb-4 col-4" hidden> 
        <label for="bulletinImage" className="form-label">Image</label>
        <input
          placeholder="bulletinImage"
          id="bulletinImage"          
          type="file"
          onChange={(e) => SetBulletinImage(e.target.files[0])}
          accept="image/*"
          className="form-control"
        />
        </div>
        <div className="mb-4 col-3">
        <label for="bulletinAudio" className="form-label">Audio</label>
        <input
          placeholder="bulletinAudio"
          id="bulletinAudio"          
          type="file"
          onChange={(e) => SetBulletinAudio(e.target.files[0])}
          className="form-control"
        />
        </div> 
        

        <div className=" row offset-6 ">  
         <button  type="reset" className="btn btn-danger col-2 mx-3"> Annuler</button>   
          {btnvalider && <button  type="button" className="btn btn-success col-2" onClick={(e) => submit(e) } data-toggle="popover" title="Popover title"  data-content="toto"  > Valider</button> }    
          
        </div> 

        </div>
        
      </form>
      
    </div>
  );// fin return
  
  
}
}

export default Postformulaire;
